function getServiceClass(record) {
  if (!record || typeof record !== 'object') return null;
  return record.serviceClass || record.category || record.class || null;
}

function setServiceClass(record, serviceClass) {
  if (!record || typeof record !== 'object') return record;
  record.serviceClass = serviceClass;
  record.class = serviceClass;
  return record;
}

function normalizePort(port) {
  var serviceClass = getServiceClass(port);
  if (serviceClass) setServiceClass(port, serviceClass);
  return port;
}

function normalizeFeed(feed) {
  var serviceClass = getServiceClass(feed);
  if (serviceClass && feed) {
    feed.serviceClass = serviceClass;
    feed.category = serviceClass;
  }
  return feed;
}

module.exports = {
  getServiceClass,
  setServiceClass,
  normalizePort,
  normalizeFeed
};
